import getPdfViewerApplication from '../../client/utils/pdfjs/pdfViewerApplication';

const enhancementManager = () => getPdfViewerApplication().enhancementManager;

export const selectInRange = (referenceType, position) => (dispatch) => {
  enhancementManager().goToReferenceAtLocation(referenceType, dispatch, null, position);
};
